import { useEinzugsdateiErstellen } from "../hooks/useLastschrift";
import type { EinzugVorschau } from "../hooks/useLastschrift";
import { fehlertext } from "../lib/fehler";

const tag = (iso: string) => new Date(iso).toLocaleDateString("de-DE");
const euro = (s: string) => `${Number(s).toLocaleString("de-DE", { minimumFractionDigits: 2 })} €`;

/**
 * Einzug per Datei: die fälligen Raten mit eigenem Mandat als pain.008
 * erzeugen. Danach im Online-Banking der Sparkasse als Sammellastschrift
 * hochladen. Ein zweiter Klick erzeugt keine zweite Datei für dieselben
 * Raten — die sind ab dem ersten als eingereicht vermerkt.
 */
export default function EinzugsdateiKnopf({ v }: { v: EinzugVorschau }) {
  const erstellen = useEinzugsdateiErstellen();
  const posten = v.posten.filter(p => !p.qonto_bereit);
  if (posten.length === 0) return null;
  const summe = posten.reduce((s, p) => s + Number(p.betrag_brutto), 0).toFixed(2);

  return (
    <>
      <button type="button" className="pf-btn ls-knopf" disabled={erstellen.isPending}
        onClick={() => erstellen.mutate()}>
        {erstellen.isPending
          ? "Erstellt…"
          : `Einzugsdatei erstellen · ${posten.length} ${posten.length === 1 ? "Rate" : "Raten"} · ${euro(summe)}`}
      </button>
      <p className="ls-text">
        Belastung am {tag(v.faellig_am)} (zum {v.einzugstag}. des Monats). Die Datei im Online-Banking der
        Sparkasse als Sammellastschrift hochladen. Ging sie nicht zur Bank, unten bei „Letzte Einzüge“
        zurücknehmen.
      </p>
      {erstellen.isSuccess && <p className="ls-text">Datei erstellt und heruntergeladen.</p>}
      {erstellen.error && <p className="ls-fehler">{fehlertext(erstellen.error)}</p>}
    </>
  );
}
